export const MOBILE_MAPPING_STATUS = '/app-api/index.php/customer/suggest_mobile_number';
export const SEND_OTP = '/app-api/index.php/customer/send_mapping_otp';
export const VERIFY_OTP = '/app-api/index.php/customer/verify_mapping_otp';
export const REDIRECT_PARAM = 'redirect';
export const MANDATORY_PARAM = 'mand';
